import { Component, ViewChild, inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { HeaderMastComponent } from '@core/components/header-mast/header-mast.component';
import { MobileMenuComponent } from '@core/components/mobile-menu/mobile-menu.component';
import { PaginationBannerComponent } from '@core/components/pagination-banner/pagination-banner.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    IonApp,
    IonRouterOutlet,
    HeaderMastComponent,
    MobileMenuComponent,
    PaginationBannerComponent,
  ],
})
export class AppComponent implements OnInit {
  @ViewChild(MobileMenuComponent) mobileMenu!: MobileMenuComponent;

  private readonly document = inject(DOCUMENT);
  private readonly showNonprodWarning = environment.showNonprodWarning;

  ngOnInit(): void {
    if (this.showNonprodWarning) {
      this.document.body.classList.add('nonprod-warning');
    }
  }

  onToggleMobileMenu(): void {
    this.mobileMenu?.toggle();
  }
}
